import { IdGameInventoryArticles } from 'shared'
import { create } from 'zustand'

export interface OnboardingStoreState {
  onboardingStep: number
  setOnboardingStep: (newOnboardingStep: number) => void
  downloadStockSource: string
  setDownloadStockSource: (newDownloadStockSource: string) => void
  finalInventoryToSave: IdGameInventoryArticles
  setFinalInventoryToSave: (newFinalInventoryToSave: IdGameInventoryArticles) => void
  writeTransactionsJobId: string
  setWriteTransactionsJobId: (newWriteTransactionsJobId: string) => void
  visitEndOnboarding: boolean
  setVisitEndOnboarding: (newVisit: boolean) => void
}

export const useOnboardingStore = create<OnboardingStoreState>()((set) => ({
  onboardingStep: 0,
  setOnboardingStep: (newOnboardingStep: number) => set({ onboardingStep: newOnboardingStep }),
  downloadStockSource: '',
  setDownloadStockSource: (newDownloadStockSource: string) =>
    set({ downloadStockSource: newDownloadStockSource }),
  finalInventoryToSave: {},
  setFinalInventoryToSave: (newFinalInventoryToSave: IdGameInventoryArticles) =>
    set({ finalInventoryToSave: newFinalInventoryToSave }),
  writeTransactionsJobId: '',
  setWriteTransactionsJobId: (newWriteTransactionsJobId: string) =>
    set({ writeTransactionsJobId: newWriteTransactionsJobId }),
  visitEndOnboarding: false,
  setVisitEndOnboarding: (newVisit: boolean) => set({ visitEndOnboarding: newVisit }),
}))
